<form [formGroup]="walletForm">
  <div class="row">
    <s1-input-text class="col-6" [control]="walletForm.controls.code" [label]="'walletModal.fields.code'" [textAlignment]="'text-right'" [readonly]="true"></s1-input-text>
    <s1-input-text class="col-6" [control]="walletForm.controls.available" [label]="'walletModal.fields.available'" [appendLabel]="'&euro;'" [textAlignment]="'text-right'" [readonly]="true"></s1-input-text>
  </div>
</form>